module.exports = __webpack_public_path__ + "static/media/close-icon.3bdeba1c.svg";